export  default [
    {
        path: "/device",
        name: "device",
        component: () => import("./List"),
        meta: {
            permiss:['DEVICE_SHOW'],
            title: "设备管理"
        }
    },
    {
        path: "/device/install",
        name: "update",
        component: () => import("./Update"),
        meta: {
            permiss:['DEVICE_ADD'],
            title: "新增"
        }
    },

    {
        path: "/device/install/:sn",
        name: "update",
        component: () => import("./Update"),
        meta: {
            permiss:['DEVICE_ADD'],
            title: "新增"
        }
    },

    {
        path: "/device/install/child/:gatewayId",
        name: "update",
        component: () => import("./AddChildDevice"),
        meta: {
            title: "新增"
        }
    },

    {
        path: "/device/detail/:id",
        name: "deviceDetail",
        component: () => import("./Detail"),
        meta: {
            permiss:['DEVICE_SHOW'],
            title: "设备详情"
        }
    },
    {
        path: "/device/updateDevice/:id",
        name: "Update",
        component: () => import("./Update"),
        meta: {
            permiss:['DEVICE_EDIT'],
            title: "设备修改"
        }
    },

]